<template>
    <div class="ns-home">
        <div class="left">
            <CardBox title="数据统计" class="left--card">
                <DataCount />
            </CardBox>
            <CardBox title="作业农机统计" class="left--card">
                <JobMachineryCount />
            </CardBox>
        </div>
        <div class="middle">
            <EchartsMap />
        </div>
        <div class="right">
            <CardBox title="农机预约" class="right--card">
                <table-info
                    :columns="subscribeColumns"
                    :table-data="appointData"
                    :limitMoveNum="5"
                />
                <template v-slot:more>
                    <span @click="handleMore">更多></span>
                </template>
            </CardBox>
            <CardBox title="农机交易" class="right--card">
                <table-info
                    :columns="transactionColumns"
                    :table-data="transactionData"
                    :limitMoveNum="5"
                />
            </CardBox>
        </div>
        <div class="footer">
            <CardBox
                title="各农机数量及面积分布"
                :bgMap="require('../../assets/images/card_footer_box.png')"
                class="footer--card"
            >
                <MachineryNumAndArea />
            </CardBox>
        </div>
    </div>
</template>
<script>
import CardBox from '@/components/CardBox'
import DataCount from './components/DataCount'
import JobMachineryCount from './components/JobMachineryCount'
import EchartsMap from './components/EchartsMap'
import TableInfo from '@/components/TableInfo'
import MachineryNumAndArea from './components/MachineryNumAndArea'
import * as fcScreenAPI from '@/api/fc-screen'
import Socket, { uri, MACHINEAPPOINT, MACHINEJOB } from '@/socket/index'
import eventHub from '@/utils/eventHub'

export default {
    components: {
        CardBox,
        DataCount,
        JobMachineryCount,
        EchartsMap,
        TableInfo,
        MachineryNumAndArea
    },
    data() {
        return {
            id: this.$route.query.id,
            subscribeColumns: [
                { title: '作业地点', field: 'locInfoAddress', width: '40%' },
                {
                    title: '所需农机',
                    field: 'machineTypeName',
                    type: 'emphasize'
                },
                { title: '作业面积', field: 'landArea' },
                { title: '预约时间', field: 'jobTimeStart' }
            ],
            appointData: [],
            transactionColumns: [
                { title: '农机类型', field: 'machineTypeName' },
                { title: '车牌号', field: 'workMachineNumber' },
                {
                    title: '操作手/时间',
                    field: 'nameTime'
                },
                { title: '作业面积', field: 'landAreaWithUnit' },
                {
                    title: '状态',
                    field: 'statusName',
                    type: 'statusColor',
                    statusField: 'status'
                }
            ],
            transactionData: []
        }
    },
    methods: {
        async getAppointData() {
            const { id } = this
            const response = await fcScreenAPI.getAmList(id)
            if (response && response.data.length) {
                this.appointData = response.data
                this.appointData.forEach((item) => {
                    const town = item.locInfo.split('/')
                    item.locInfoAddress = town[town.length - 1] + item.address
                    item.landArea = `${item.landArea}亩`
                })
            }
        },
        async getTransactionData() {
            const { id } = this
            const response = await fcScreenAPI.getTaskData(id)
            if (response && response.data.length) {
                this.transactionData = response.data
                this.transactionData.forEach((item) => {
                    item.nameTime = `${item.orderReceiverName}/${
                        item.jobTimeStart.split(' ')[0]
                    }`
                })
            }
        },
        handleMore() {
            const {
                $route: {
                    query: { id, mode }
                }
            } = this
            this.$router.push({
                name: 'moreAppointment',
                query: { id, mode, jump: 'ns-home', tag: 'fc-screen' }
            })
        }
    },
    mounted() {
        this.getAppointData()
        this.getTransactionData()

        // 初始化 socket
        Socket.inits(uri)

        // 接收 socket 农机预约信息
        eventHub.$on(MACHINEAPPOINT, (data) => {
            const town = data.locInfo.split('/')
            data.locInfoAddress = town[town.length - 1] + data.address
            data.landArea = `${data.landArea}亩`
            const index = this.appointData.findIndex(
                (item) => item.id === data.id
            )
            if (index === -1) {
                this.appointData.unshift(data)
            } else {
                this.appointData.splice(index, 1)
                this.appointData.unshift(data)
            }
        })
        // 接收 socket 农机交易信息
        eventHub.$on(MACHINEJOB, (data) => {
            data.nameTime = `${data.orderReceiverName}/${
                data.jobTimeStart.split(' ')[0]
            }`
            const index = this.transactionData.findIndex(
                (item) => item.id === data.id
            )
            if (index === -1) {
                this.transactionData.unshift(data)
            } else {
                this.transactionData.splice(index, 1)
                this.transactionData.unshift(data)
            }
        })
    },
    destroyed() {
        // 销毁 socket
        Socket.destroy()

        eventHub.$off(MACHINEJOB)
    }
}
</script>
<style lang="scss" scoped>
.ns-home {
    position: relative;
    width: 100%;
    height: 100%;
    .left,
    .middle,
    .right {
        width: 620px;
        height: 690px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        &--card {
            width: 100%;
            height: calc(50% - 6px);
        }
    }
    .footer {
        position: absolute;
        bottom: 15px;
        width: calc(100% - 30px);
        height: 263px;
        &--card {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
